import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=be20304e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=be20304e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20304e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be20304e')) {
      api.createRecord('be20304e', component.options)
    } else {
      api.reload('be20304e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=be20304e&scoped=true&", function () {
      api.rerender('be20304e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nc33SeasUK53/JS/comp/GuestBox.vue"
export default component.exports